import APIClient from './index';
import _ from 'lodash';

export const getScopeWheelHeroes = async () => {
  const heroes = [];
  let beforeId;
  try {
    do {
      const { data } = await APIClient.get('ScopeWheelHeroes', { params: { limit: 100, ...(beforeId && { beforeId }) } });
      heroes.push(...data.heroes);
      const nextCursor = data.nextCursor;
      if (nextCursor != null && (!Number.isSafeInteger(nextCursor) || nextCursor <= 0 || (beforeId && nextCursor >= beforeId))) {
        throw new Error('Invalid hero page cursor.');
      }
      beforeId = nextCursor;
    } while (beforeId != null);
    return heroes;
  } catch (err) {
    throw _.get(err, 'response.data.error') || 'Failed to load the wheel.';
  }
};

export const createScopeWheelHero = hero =>
  new Promise((resolve, reject) => {
    APIClient.post('ScopeWheelHeroes', hero)
      .then(response => resolve(response.data.hero))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to add that hero.'));
  });

export const updateScopeWheelHero = (id, updates) =>
  new Promise((resolve, reject) => {
    APIClient.put(`ScopeWheelHeroes/${id}`, updates)
      .then(response => resolve(response.data.hero))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to update that hero.'));
  });

export const deleteScopeWheelHero = id =>
  new Promise((resolve, reject) => {
    APIClient.delete(`ScopeWheelHeroes/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to remove that hero.'));
  });

export const proposeScopeWheelHeroes = extraContext =>
  new Promise((resolve, reject) => {
    APIClient.post('ScopeWheelHeroes/propose', { extraContext })
      .then(response => resolve(response.data.heroes))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Could not spin up new ideas.'));
  });

export const searchScopeWheelTargets = (kind, q) =>
  new Promise((resolve, reject) => {
    APIClient.get('ScopeWheelHeroes/targets', { params: { kind, q } })
      .then(response => resolve(response.data.results || []))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to search.'));
  });

export const getScopeWheelHeroTags = () =>
  APIClient.get('ScopeWheelHeroes/tags').then(response => response.data.groups);
